<template>
    <li :class="classAttr">
        <b-link
            :id="linkId"
            :class="{ 'nav-link':true, 'disabled':item.disabled }"
            :disabled="item.disabled"
            :to="item.path">
            <FontAwesomeIcon v-if="linkIcon" :icon="linkIcon" fixed-width />
            <!-- <span class="link-label">{{item.label}}</span> -->
            <span class="link-label">{{linkText}}</span>
            <!-- <b-badge v-if="showBadge" variant="light-purple" pill>{{badgeText}}</b-badge> -->
        </b-link>
    </li>
</template>

<script>
    export default {
        name: "SidebarNavLink",
        props: {
            linkId: { type: String, default: () => { return _.uniqueId("sb-nav-link-"); } },
            item: { type: Object, required: true, default: () => {} }
        },
        watch: {
            $route: {
                handler(newVal, oldVal){
                    this.item.exactMatch = this.routeIsExactMatch();
                },
                immediate:true
            }
        },
        computed: {
            linkIcon() { return this.item.icon; },
            currentRouteName () { return _.get(this, "$route.name", null); },
            isActive() { return this.item.exactMatch || (this.item.children && _.some(this.item.children, child => child.exactMatch)); },
            classAttr() {
                return {
                    [`nav-item level-${this.item.level}`]: true,
                    "open active rq-exact-active": this.isActive,
                    "disabled": this.item.disabled
                };
            },
            customPageName() {
                return _.isEmpty(this.systemDefaults?.customPageName)
                    ? "Custom Page"
                    : this.systemDefaults.customPageName;
            },
            linkText() {
                return this.item.label;
            },
            // badgeText() {
            //     if(this.item.label !== "Alerts")
            //         return _.get(this, "item.badge.text", null);
            //     return this.unreadAlertCount;
            // },
            // showBadge() {
            //     return !_.isNil(this.badgeText);
            // }
        },
        methods:{
            routeIsExactMatch(){
                return (!_.isEmpty(this.item.name) && this.item.name === this.$route.name) || (!_.isEmpty(this.item.matchRoutePrefix) && _.startsWith(this.$route.name, `${this.item.matchRoutePrefix}:`));
            }
        }
    };
</script>